import savingsIcon from "@/features/offers/assets/icons/savings.svg"
import { OfferDisclaimer } from "./offer-disclaimer"

interface OfferPaymentProps {
  heading: string
  reportLabel: string
  reportWas?: string
  reportNow: string
  giftLabel: string
  giftStrike: string
  ctaLabel: string
  purchasing?: boolean
  /** Show the money-back + subscription-consent block (subscription offers only). */
  showDisclaimer?: boolean
  /** Plan-aware consent copy for the disclaimer (built from the offer plan). */
  consentText?: string
  onUnlock: () => void
}

/**
 * Price summary + gradient CTA. The money-back/legal block is shown only for
 * recurring-subscription offers (`showDisclaimer`); one-time offers omit it.
 */
export function OfferPayment({
  heading,
  reportLabel,
  reportWas,
  reportNow,
  giftLabel,
  giftStrike,
  ctaLabel,
  purchasing = false,
  showDisclaimer = false,
  consentText,
  onUnlock,
}: OfferPaymentProps) {
  return (
    <div data-slot="offer-payment" className="flex flex-col gap-4">
      <h2 className="text-center font-display text-2xl font-medium text-purple-light">{heading}</h2>

      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <span className="whitespace-nowrap text-base text-purple-light/70">{reportLabel}</span>
          <span className="h-px flex-1 bg-purple-light/20" />
          <span className="flex items-center gap-1 whitespace-nowrap text-base">
            {reportWas && <span className="text-purple-light/40 line-through">{reportWas}</span>}
            <span className="font-semibold text-purple-light">{reportNow}</span>
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="whitespace-nowrap text-base text-purple-light/70">{giftLabel}</span>
          <span className="h-px flex-1 bg-purple-light/20" />
          <div className="flex items-center gap-2">
            <span className="whitespace-nowrap text-base text-purple-light/40 line-through">
              {giftStrike}
            </span>
            <span className="flex items-center gap-1 rounded-[20px] bg-peach/20 px-2 py-1">
              <img src={savingsIcon} alt="" className="h-3 w-2.5" />
              <span className="text-[10px] font-bold text-peach">FREE</span>
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onUnlock}
        disabled={purchasing}
        data-offer-cta
        className="flex h-14 w-full items-center justify-center gap-1 rounded-full bg-gradient-to-b from-peach to-purple-accent text-base font-semibold text-white transition-opacity hover:opacity-90 disabled:bg-none disabled:bg-purple-light/10 disabled:text-purple-light/70"
      >
        {purchasing ? (
          <>
            <span className="size-5 animate-spin rounded-full border-2 border-purple-light border-t-transparent" />
            Processing…
          </>
        ) : (
          ctaLabel
        )}
      </button>

      {showDisclaimer && consentText && <OfferDisclaimer consentText={consentText} />}
    </div>
  )
}
